<template>
  <form id="newRecord" @submit.prevent="saveOrUpdateDocumentType">
    <c-422-errors :errors="errors" />
    <div class="mb-3">
      <label for="name" class="form-label">Nombre:</label>
      <input
        v-model="documentType.name"
        class="form-control"
        id="name"
        required
      />
    </div>
    <c-primary-button class="w-100" :disabled="loading">
      Guardar
    </c-primary-button>
  </form>
</template>
<script>
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import C422Errors from "@/components/C422Errors";
import { create, update, find } from "@/services/document_types";
import { showNotification } from "@/services/notification";

export default {
  components: {
    C422Errors,
    CPrimaryButton,
  },
  data() {
    return {
      errors: {},
      loading: false,
      documentType: {
        name: "",
      },
      documentTypeId: this.$route.params.id,
    };
  },
  mounted() {
    this.getDocumentType();
  },
  methods: {
    getDocumentType() {
      if (!this.documentTypeId) {
        return;
      }
      find(this.documentTypeId).then((response) => {
        this.documentType = response.data;
      });
    },
    saveOrUpdateDocumentType() {
      if (this.documentTypeId) {
        this.updateDocumentType();
      } else {
        this.saveDocumentType();
      }
    },
    saveDocumentType() {
      create(this.documentType).then(() => {
        showNotification(201);
        this.$router.push("/admin/tipos-de-documentos");
      });
    },
    updateDocumentType() {
      update(this.documentTypeId, this.documentType).then(() => {
        showNotification(201);
        this.$router.push("/admin/tipos-de-documentos");
      });
    },
  },
};
</script>
